import React from "react";

const Contact = () => {
  return (
    <section className="text-gray-600 body-font relative sm:pt-9 bg-gray-50">
      <div className="container px-5 py-10 mx-auto flex sm:flex-nowrap flex-wrap">
        <div className="lg:w-2/3 md:w-1/2 bg-white w-full rounded-lg overflow-hidden sm:mr-10 sm:p-10 p-32 flex items-end justify-start relative">
          <iframe
            className="inset-0 absolute"
            width="100%"
            height="100%"
            frameBorder="0"
            title="map"
            marginHeight="0"
            marginWidth="0"
            scrolling="no"
            src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_MAPS_KEY}&q=Βασιλική Μαργαριτοπούλου, Ογλ, Βόλος, Greece`}
          />
        </div>
        <div className="lg:w-1/3 md:w-1/2 px-10 sm:px-10 bg-white flex flex-col md:ml-auto w-full py-6 md:py-8 mt-8 md:mt-0 rounded-xl shadow-sm">
          <h2 className="text-gray-900 text-lg mb-1 font-medium title-font border-b-2 border-gray-200 border-opacity-60">Ωράριο*</h2>
          <div className="grid grid-cols-3 gap-x-3 text-start border-b-2 border-gray-200 border-opacity-60 pb-4 pt-3">
            <p className="text-gray-900 sm:text-lg text-m font-medium title-font">Δευτέρα:</p>
            <p className="leading-relaxed mb-0 text-gray-600">09:30 - 13:00</p>
            <p className="leading-relaxed mb-0 text-gray-600">17:30 - 21:00</p>

            <p className="text-gray-900 sm:text-lg text-m font-medium title-font">Τρίτη:</p>
            <p className="leading-relaxed mb-0 text-gray-600">09:30 - 13:00</p>
            <p className="leading-relaxed mb-0 text-gray-600">17:30 - 21:00</p>

            <p className="text-gray-900 sm:text-lg text-m font-medium title-font">Τετάρτη:</p>
            <p className="leading-relaxed mb-0 text-gray-600">09:30 - 15:00</p>
            <p className="leading-relaxed mb-0 text-gray-600">Κλειστά</p>

            <p className="text-gray-900 sm:text-lg text-m font-medium title-font">Πέμπτη:</p>
            <p className="leading-relaxed mb-0 text-gray-600">09:30 - 13:00</p>
            <p className="leading-relaxed mb-0 text-gray-600">17:30 - 21:00</p>

            <p className="text-gray-900 sm:text-lg text-m font-medium title-font">Παρασκευή:</p>
            <p className="leading-relaxed mb-0 text-gray-600">09:30 - 13:00</p>
            <p className="leading-relaxed mb-0 text-gray-600">Κλειστά</p>

            <p className="text-gray-900 sm:text-lg text-m font-medium title-font">Σάββατο:</p>
            <p className="leading-relaxed mb-0 text-gray-600">Κλειστά</p>
            <p className="leading-relaxed mb-0 text-gray-600"> </p>

            <p className="text-gray-900 sm:text-lg text-m font-medium title-font">Κυριακή:</p>
            <p className="leading-relaxed mb-0 text-gray-600">Κλειστά</p>
            <p className="leading-relaxed mb-0 text-gray-600"> </p>
          </div>
          <h2 className="text-gray-900 text-lg mb-1 font-medium title-font text-left pt-4">
            Τηλ. επικοινωνίας: <i className="fa-solid fa-phone text-lg leading-lg text-gray-900 opacity-75"></i> +30 24210 32200
          </h2>
          <p className="text-xs text-gray-500 mt-3">* το ωράριο μπορεί να διαφέρει εν καιρό εορτών.</p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
